import { render, staticRenderFns } from "./SAFFUploaderForm.vue?vue&type=template&id=31c4353c&"
import script from "./SAFFUploaderForm.vue?vue&type=script&lang=ts&"
export * from "./SAFFUploaderForm.vue?vue&type=script&lang=ts&"
import style0 from "./SAFFUploaderForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports